export const TEAM_CREATE_PROVIDES = 'TEAM_CREATE_PROVIDES';
